var GU = 8;
var RADIUS = 4;
export { GU, RADIUS };